module.exports = "img/videos/23.8dd470.mp4";